import { MenuItem, styled } from '@mui/material';

export const SortMenuItem = styled(MenuItem)`
  margin: 4px 8px;
  &&:hover {
    background-color: ${({ theme }) => theme.palette.info.light};
  }

  &&.Mui-selected {
    background-color: ${({ theme }) => theme.palette.info.p020};
  }

  &&.Mui-selected:hover {
    background-color: ${({ theme }) => theme.palette.info.p030};
  }
`;
